import React, { useEffect } from "react";
import { Provider, useSelector, useDispatch } from "react-redux";
import { store, persistor } from "./store";
import { PersistGate } from "redux-persist/integration/react";
import {
  HashRouter as Router,
  Switch,
  Redirect,
  useHistory
} from "react-router-dom";
import "moment/locale/es";
import { Route } from "components";
import { RootState } from "reducers";
import { Socket, SocketEvents, Constants, Globals } from 'utils';
import { AuthService } from 'services';

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

// Public
import Home from 'screens/home';
import Chat from 'screens/chat/chat';

// Auth
import Login from "screens/auth/login/login";
import Recover from "screens/auth/login/recover";
import Reset from "screens/auth/login/reset";
import Profile from "screens/profile";
import Register from "screens/auth/register/register";
import SelectLevel from "screens/auth/register/select-level";
import RegisterMedic from "screens/auth/register/vet/register-medic";
import RegisterClinic from "screens/auth/register/clinic/register-clinic";
import RegisterBusiness from "screens/auth/register/business/register-business";

// Admin Home
import Admin from 'screens/admin/home';
import AdminHome from 'screens/admin/home/home';
//import AdminHome from 'screens/admin/home';
import AdminPlansList from 'screens/admin/plans/plans';
import AdminPlansHistory from 'screens/admin/plans/history';
import AdminServices from 'screens/admin/services/services';
import AdminSpecialities from 'screens/admin/specialities/specialities';
import AdminQuotes from 'screens/admin/quotes/quotes';
import AdminModerators from 'screens/admin/moderators/moderators';
import AdminBanks from 'screens/admin/banks/banks';
import AdminBanners from 'screens/admin/banners/banners';
import AdminRegister from 'screens/admin/register/register';
import Categories from "screens/admin/categories/categories";
import Advertisement from "screens/admin/advertisement/advertisement";
import Commissions from "screens/admin/commissions/commissions";
import AdminNotifications from "screens/admin/notifications/notifications";
import AdminCalifications from "screens/admin/califications/calification";
import AdminPayments from "screens/admin/payments/payments";

// Affiliate
import AffiliateRenew from 'screens/affiliate/renew';
import AffiliatePlan from 'screens/affiliate/plan';
import AffiliateAds from 'screens/affiliate/ads/ads';
import AffiliateTeleconsultation from 'screens/affiliate/teleconsultations/teleconsultations';
import AffiliateProfile from "screens/affiliate/profile/profile";
// Clinic
import Clinic from 'screens/clinic/home';
import ClinicHome from 'screens/clinic/home/home';
import ClinicPlan from 'screens/clinic/plan/plan';
import ClinicQuotes from 'screens/clinic/quotes/quotes';
import ClinicServices from 'screens/clinic/services/services';

// Doctor
import Doctor from 'screens/doctor/home';
import DoctorHome from 'screens/doctor/home/home';
import DoctorPlan from 'screens/doctor/plan/plan';
import DoctorQuotes from 'screens/doctor/quotes/quotes';
import DoctorServices from 'screens/doctor/services/services';

// Business
import Business from 'screens/business/home';
import BusinessHome from 'screens/business/home/home';

// Scripts
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.min.js";

// Styles
import "bootstrap/dist/css/bootstrap.min.css";
import "font-awesome/css/font-awesome.min.css";
import "./scss/main.scss";

const Container = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  useEffect(() => {
    const getUser = async () => {
      const user = store.getState().user;
      if (user) {
        const res: any = await AuthService.checkUser({
          user_id: user?.id,
          withoutLoading: true
        });
        if (res.user) {
          if (res.user?.status == Constants.USER_STATUS.ACTIVE) {
            dispatch({
              type: 'SET_USER',
              payload: res.user
            });
          }
          else {
            Globals.showError("Lo sentimos, su usuario ha sido suspendido");
            close();
          }
        }
        else {
          Globals.showError("Lo sentimos, su usuario ha sido eliminado");
          close();
        }
      }
    }
    getUser();

    const close = async () => {
      await dispatch({
        type: 'SET_USER',
        payload: null
      });
      history.replace('/logout');
    }

    Socket.on(SocketEvents.UPDATE_USER, (data: any) => {
      const user = store.getState().user;
      if (user != null && user?.id == data.user_id) {
        getUser();
      }
    });
  }, []);

  return (
    <React.Fragment>
      <Switch>
        {/* Public */}
        <Route exact path="/" component={Home} />

        {/* Auth */}
        <Route exact noAuth path="/login" component={Login} />
        <Route exact auth path="/profile" component={Profile} />
        <Route exact noAuth path="/recover" component={Recover} />
        <Route exact noAuth path="/recover/:code" component={Reset} />
        <Route exact noAuth path="/register/select-level" component={SelectLevel} />
        <Route exact noAuth path="/register/medic" component={RegisterMedic} />
        <Route exact noAuth path="/register/clinic" component={RegisterClinic} />
        <Route exact noAuth path="/register/business" component={RegisterBusiness} />
        {/* affiliate profile */}
        <Route exact auth path="/affiliate-profile" component={AffiliateProfile} />
        {/* Admin */}

        {/* Home */}
        <Route exact admin path="/admin" component={Admin} />
        <Route exact admin path="/admin/home" component={AdminHome} />

        {/* Categories */}
        <Route exact admin path="/admin/categories" component={Categories} />

        {/* Notificaciones */}
        <Route exact admin path="/admin/notifications" component={AdminNotifications} permission={Constants.MODULES.REGISTER} />

        {/* Registro de pagos */}
        <Route exact admin path="/admin/payments" component={AdminPayments} permission={Constants.MODULES.REGISTER} />

        {/* Calificaciones */}
        <Route exact admin path="/admin/califications" component={AdminCalifications} permission={Constants.MODULES.REGISTER} />

        {/* Quotes */}
        <Route exact admin path="/admin/quotes" component={AdminQuotes} permission={Constants.MODULES.QUOTES} />

        {/* Register */}
        <Route exact admin path="/admin/register" component={AdminRegister} permission={Constants.MODULES.REGISTER} />

        {/* gestion de publicidad */}
        <Route exact admin path="/admin/advertisement" component={Advertisement} permission={Constants.MODULES.REGISTER} />

        {/* Comisiones */}
        <Route exact admin path="/admin/commissions" component={Commissions} permission={Constants.MODULES.COMMISSIONS} />

        {/* Banks */}
        <Route exact admin path="/admin/banks" component={AdminBanks} permission={Constants.MODULES.BANK_ACCOUNTS} />

        {/* Banners */}
        <Route exact admin path="/admin/banners" component={AdminBanners} permission={Constants.MODULES.BANNERS} />

        {/* Plans */}
        <Route exact admin path="/admin/plans" component={AdminPlansList} permission={Constants.MODULES.PLANS} />
        <Route exact admin path="/admin/plans/history" component={AdminPlansHistory} permission={Constants.MODULES.PLANS} />

        {/* Moderators */}
        <Route exact admin path="/admin/moderators" component={AdminModerators} permission={Constants.MODULES.MODERATORS} />

        {/* Services */}
        <Route exact admin path="/admin/services" component={AdminServices} permission={Constants.MODULES.SERVICES} />

        {/* Specialities */}
        <Route exact admin path="/admin/specialities" component={AdminSpecialities} permission={Constants.MODULES.SPECIALITIES} />

        {/* Common Affiliate */}
        <Route exact business path="/affiliate/renew" component={AffiliateRenew} />
        <Route exact business path="/affiliate/plan" component={AffiliatePlan} />
        <Route exact business path="/affiliate/ads" component={AffiliateAds} />
        <Route exact business path="/affiliate/teleconsultation" component={AffiliateTeleconsultation} />

        {/* Clinic */}

        {/* Home */}
        <Route exact clinic path="/clinic" component={Clinic} />
        <Route exact clinic path="/clinic/home" component={ClinicHome} />

        {/* Chat */}
        <Route exact clinic path="/clinic/chat" component={Chat} />

        {/* Plan */}
        <Route exact clinic path="/clinic/plan" component={ClinicPlan} />

        {/* Services */}
        <Route exact clinic path="/clinic/services" component={ClinicServices} />

        {/* Quotes */}
        <Route exact clinic path="/clinic/quotes" component={ClinicQuotes} />

        {/* Doctor */}

        {/* Home */}
        <Route exact doctor path="/doctor" component={Doctor} />
        <Route exact doctor path="/doctor/home" component={DoctorHome} />

        {/* Chat */}
        <Route exact doctor path="/doctor/chat" component={Chat} />

        {/* Plan */}
        <Route exact doctor path="/doctor/plan" component={DoctorPlan} />

        {/* Services */}
        <Route exact doctor path="/doctor/services" component={DoctorServices} />

        {/* Quotes */}
        <Route exact doctor path="/doctor/quotes" component={DoctorQuotes} />

        {/* Business */}

        {/* Home */}
        <Route exact business path="/business" component={Business} />
        <Route exact business path="/business/home" component={BusinessHome} />

        {/* Chat */}
        <Route exact business path="/business/chat" component={Chat} />

        <Redirect to="/" />
      </Switch>
    </React.Fragment>
  )
}

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router>
        <Container />
      </Router>
    </PersistGate>
  </Provider>
);

export default App;
